import getConfig from "next/config";
import React, { useState } from "react";
import { twJoin } from "tailwind-merge";

import { SessionState } from "./SessionState";
import { ShowKeys } from "./ShowKeys";
import AnimatedTuneIcon from "@components/shared/Icons/AnimatedTune";

import { BUSINESS_ENVIRONMENTS } from "@shared/constants";

const { publicRuntimeConfig } = getConfig();
const { BUSINESS_ENV } = publicRuntimeConfig;

export const DevBox = () => {
  const [isVisible, setIsVisible] = useState(false);

  if (BUSINESS_ENV === BUSINESS_ENVIRONMENTS.PRODUCTION) {
    return null;
  }

  return (
    <div className="fixed bottom-0.5 left-0.5 z-100">
      <button
        className={twJoin(
          "grid place-items-center size-6 rounded-full border border-primaryDark/70 text-sm cursor-pointer transition-all z-10 relative text-primaryOrange",
          isVisible ? "bg-gray-200" : "bg-white hover:bg-gray-200"
        )}
        onClick={() => setIsVisible(!isVisible)}
      >
        <AnimatedTuneIcon className="size-4" />
      </button>
      {isVisible && (
        <div className="flex flex-col gap-1 absolute bottom-7 left-0 bg-white border border-primaryDark/70 rounded-lg p-2 shadow-lg z-0">
          <SessionState />
          <ShowKeys />
        </div>
      )}
    </div>
  );
};
